import React, { PropTypes } from 'react'
import classNames from 'classnames'
import CSSModules from 'react-css-modules'

import styles from './loader.css'

const Loader = ({ center }) => {
  const className = classNames('loader', {
    'loader-center': center,
  })

  return (
    <div styleName={className}>
      <span styleName="dot" />
      <span styleName="dot" />
      <span styleName="dot" />
    </div>
  )
}

Loader.propTypes = {
  center: PropTypes.bool,
}

export default CSSModules(Loader, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/loader/loader.js
 **/